import { FilterCheckboxGroup } from '@src/components/planet/filter/filterCheckbox/FilterCheckboxGroup'
import { useCallback } from 'react'

export const SingleFilterCheckboxGroup = <T extends unknown>(
  props: Props<T>
) => {
  const { className, label, items, onChange, value } = props

  const checkedValue = value === undefined ? [] : [value]

  const onCheckboxChange = useCallback(
    (value: T[]) => {
      if (value.length > 0) {
        onChange?.(value[value.length - 1])
      } else {
        onChange?.(undefined)
      }
    },
    [onChange]
  )

  return (
    <FilterCheckboxGroup
      className={className}
      label={label}
      items={items}
      value={checkedValue}
      onChange={onCheckboxChange}
    />
  )
}

export type FilterCheckboxItem<T> = {
  name: string
  label: string
  value: T
}

type Props<T> = {
  className?: string
  label: string
  items: FilterCheckboxItem<T>[]
  value?: T
  onChange?: (value?: T) => void
}
